import LandingHeader from "../../pages/LandingPage/LandingHeader";
import HelpPage from "../Help/HelpPage";
import Footer from "../Footer/Footer";

const SupportPage = () => {
  return (
    <>
      <LandingHeader />
      <HelpPage />
      <Footer />
    </>
  );
};

export default SupportPage;
